<template>
  <div class="report-wrap">
    <div class="slide-wrap">
      <el-menu :default-active="curMenu" class="slide-menu" @select="handleSelect">
        <el-submenu v-for="item of menuList" :key="item.menuId" :index="item.menuId + ''">
          <template slot="title">
            <div class="menu-header">
              <svg-icon :iconClass="item.icon" className="menu-icon"></svg-icon>
              <span>{{ item.menuName }}</span>
            </div>
          </template>
          <el-menu-item v-for="child of item.children" :key="child.menuId" class="menu-item" :index="child.menuAdr">
            <svg-icon :iconClass="child.icon" className="child-icon"></svg-icon>{{ child.menuName }}</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </div>
    <div class="content-wrap">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <router-view />
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  name: "Report",
  components: {
    SvgIcon,
  },
  data() {
    return {
      menuList: [],
      curMenu: "",
    };
  },
  mounted() {
    this.initMenu();
  },
  updated() {
    this.setCurIndex();
  },
  methods: {
    dataToTree(parents, children) {
      parents.forEach((p) => {
        children.forEach((c, i) => {
          if (c.parentId === p.menuId) {
            let _c = JSON.parse(JSON.stringify(children));
            _c.splice(i, 1);
            this.dataToTree([c], _c);
            if (p.children) {
              p.children.push(c);
            } else {
              p.children = [c];
            }
          }
        });
      });
    },
    initMenu() {
      let menuList = JSON.parse(localStorage.getItem("userInfo")).menu;
      let parents = [];
      let children = [];
      let rootItem = menuList.find((item) => item.menuName === "广告账户管理");
      parents.push(rootItem);
      if (rootItem) {
        let rootId = rootItem.menuId;
        menuList.forEach((item) => {
          if (item.parentId === rootId) {
            children.push(item);
          }
        });
        this.dataToTree(parents, children);
        this.curMenu = parents[0].children[0].menuAdr;
        this.menuList = parents;
      }
    },
    handleSelect(key) {
      this.$router.push("/" + key);
    },
    //设置当前聚焦菜单
    setCurIndex() {
      let curRouter = this.$router.currentRoute.path;
      if (curRouter === "/ads") {
        this.$router.replace("/ads/toutiao.html");
      } else {
        this.curMenu = curRouter.replace(/^\//g, "");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-wrap {
  display: flex;
  height: calc(100vh - 40px);
  .slide-wrap {
    flex-shrink: 0;
    width: 183px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding-top: 16px;
    .slide-menu {
      .menu-header {
        font-size: 15px;
        font-weight: bold;
        color: rgba(24, 144, 255, 1);
        .menu-icon {
          font-size: 18px;
          position: relative;
          right: 5px;
          top: 1px;
        }
      }
      .menu-item {
        min-width: 183px;
        height: 32px;
        line-height: 32px;
        margin: 4px 0;
        color: rgba(0, 0, 0, 0.64);
        font-size: 14px;
        .child-icon {
          font-size: 18px;
          position: relative;
          right: 10px;
          top: 1px;
        }
        &.is-active {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
          background: rgba(24, 144, 255, 0.1);
        }
      }
      /deep/ .el-submenu__title i {
        color: #909399;
      }
    }
  }
  .content-wrap {
    width: calc(100% - 180px);
  }
}
</style>
